module.exports = __webpack_public_path__ + "static/media/cancel_icon.160e2053.svg";